import React, {Fragment, useEffect} from 'react';
import { connect } from "react-redux";
import OrderRecivedSec from '../../components/OrderRecivedSec';
import NewNavbar from '../../new-components/NewNavbar'
import NewPageHeader from "../../new-components/NewPageHeader";
import NewOverrides from '../../new-components/NewOverrides'
import NewDesignSystem from '../../new-components/NewDesignSystem'
import NewFooter from '../../new-components/NewFooter'
import NewMadeWith from '../../new-components/NewMadeWith'
import NewScrollTop from '../../new-components/NewScrollTop'


const OrderRecived =({cartList}) => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return(
        <Fragment>
             <NewNavbar/>
             <NewOverrides/>
             <NewDesignSystem/>

      <NewPageHeader />
             <OrderRecivedSec cartList={cartList}/>
             <NewFooter/>
             <NewMadeWith/>
             <NewScrollTop/>
        </Fragment>
    )
};

const mapStateToProps = state => {
    return {
        cartList: state.cartList.cart,
        symbol: state.data.symbol
    }
};

export default connect(mapStateToProps)(OrderRecived);
